module.exports = __webpack_public_path__ + "img/cnc-03-plant-species.343d5354.svg";